export const home = {
  is: {
    hero: {
      badge: "Faglegar veflausnir",
      title: "Sérfræðingar í <span class='relative z-10 bg-gradient-to-r from-[#EA295A] to-[#FF6B6B] bg-clip-text text-transparent'>stafrænum lausnum</span>",
      description: "Við hjálpum fyrirtækjum að ná árangri á netinu með sérsniðnum veflausnum, faglegri hönnun og framúrskarandi þjónustu.",
      exploreServices: "Skoða þjónustu",
      imageAlt: "Vefsíðugerð"
    },
    stats: {
      clients: "Ánægðir viðskiptavinir",
      projects: "Verkefni kláruð",
      uptime: "Uppitími",
      support: "Þjónusta"
    },
    clients: {
      title: "Viðskiptavinir okkar",
      description: "Við erum stolt af því að vinna með leiðandi fyrirtækjum og stofnunum"
    },
    services: {
      title: "Þjónusta",
      description: "Sérsniðnar lausnir sem henta þínum þörfum og markmiðum",
      webDevelopment: {
        description: "Sérsniðnar veflausnir sem skila árangri",
        features: {
          responsive: "Snjalltækjavæn hönnun",
          seo: "SEO vænt",
          fast: "Hraðvirkt"
        }
      },
      webDesign: {
        description: "Nútímaleg hönnun sem fangar athygli",
        features: {
          ux: "UX/UI hönnun",
          branding: "Vörumerkjahönnun",
          prototype: "Frumgerð"
        }
      },
      webProgramming: {
        description: "Öflug og skilvirk forritun",
        features: {
          custom: "Sérsniðnar lausnir",
          api: "API þróun",
          programming: "Forritun"
        }
      },
      seo: {
        description: "Hámarkar sýnileika á netinu",
        features: {
          keywords: "Lykilorðagreining",
          technical: "Tæknileg bestun",
          content: "Efnisbestun"
        }
      },
      marketing: {
        description: "Markviss stafræn markaðssetning",
        features: {
          social: "Samfélagsmiðlar",
          ads: "Auglýsingar",
          content: "Efnismarkaðssetning"
        }
      },
      analytics: {
        description: "Ítarleg greining og mælingar",
        features: {
          google: "Google Analytics",
          heatmap: "Hitakort",
          testing: "A/B prófanir"
        }
      }
    },
    solutions: {
      title: "Lausnir",
      description: "Sérhannaðar lausnir fyrir þitt fyrirtæki",
      ai: {
        description: "AI lausnir fyrir fyrirtæki",
        features: {
          chatbot: "Spjallmenni",
          automation: "Sjálfvirkni",
          analysis: "Greining"
        }
      },
      booking: {
        description: "Sjálfvirk bókunarkerfi",
        features: {
          online: "Netbókanir",
          payment: "Greiðslugáttir",
          reminders: "Áminningar"
        }
      },
      subscription: {
        description: "Recurring revenue lausnir",
        features: {
          management: "Áskriftarstýring",
          payment: "Greiðslur",
          users: "Notendastýring"
        }
      },
      ecommerce: {
        description: "Öflug netverslun",
        features: {
          products: "Vörustjórnun",
          payment: "Greiðslugáttir",
          shipping: "Sendingar"
        }
      },
      pos: {
        description: "Nútímalegt kassakerfi",
        features: {
          sales: "Sölukerfi",
          inventory: "Birgðastýring",
          reports: "Skýrslur"
        }
      },
      wordpress: {
        description: "WordPress lausnir",
        features: {
          cms: "Efnisstjórnun",
          plugins: "Viðbætur",
          themes: "Þemu"
        }
      }
    },
    cta: {
      title: "Tilbúin að hefja þitt verkefni?",
      description: "Láttu okkur hjálpa þér að ná þínum markmiðum með öflugum stafrænum lausnum"
    }
  },
  en: {
    hero: {
      badge: "Professional Web Solutions",
      title: "Experts in <span class='relative z-10 bg-gradient-to-r from-[#EA295A] to-[#FF6B6B] bg-clip-text text-transparent'>digital solutions</span>",
      description: "We help businesses succeed online with custom web solutions, professional design, and exceptional service.",
      exploreServices: "Explore Services",
      imageAlt: "Web Development"
    },
    stats: {
      clients: "Happy Clients",
      projects: "Projects Completed",
      uptime: "Uptime",
      support: "Support"
    },
    clients: {
      title: "Our Clients",
      description: "We are proud to work with leading companies and organizations"
    },
    services: {
      title: "Services",
      description: "Custom solutions tailored to your needs and goals",
      webDevelopment: {
        description: "Custom web solutions that deliver results",
        features: {
          responsive: "Responsive design",
          seo: "SEO friendly",
          fast: "Fast loading"
        }
      },
      webDesign: {
        description: "Modern design that captures attention",
        features: {
          ux: "UX/UI design",
          branding: "Brand design",
          prototype: "Prototype"
        }
      },
      webProgramming: {
        description: "Powerful and efficient programming",
        features: {
          custom: "Custom solutions",
          api: "API development",
          programming: "Programming"
        }
      },
      seo: {
        description: "Maximizes online visibility",
        features: {
          keywords: "Keyword analysis",
          technical: "Technical optimization",
          content: "Content optimization"
        }
      },
      marketing: {
        description: "Targeted digital marketing",
        features: {
          social: "Social media",
          ads: "Advertising",
          content: "Content marketing"
        }
      },
      analytics: {
        description: "Detailed analysis and measurements",
        features: {
          google: "Google Analytics",
          heatmap: "Heatmaps",
          testing: "A/B testing"
        }
      }
    },
    solutions: {
      title: "Solutions",
      description: "Custom solutions for your business",
      ai: {
        description: "AI solutions for businesses",
        features: {
          chatbot: "Chatbots",
          automation: "Automation",
          analysis: "Analysis"
        }
      },
      booking: {
        description: "Automated booking systems",
        features: {
          online: "Online bookings",
          payment: "Payment gateways",
          reminders: "Reminders"
        }
      },
      subscription: {
        description: "Recurring revenue solutions",
        features: {
          management: "Subscription management",
          payment: "Payments",
          users: "User management"
        }
      },
      ecommerce: {
        description: "Powerful e-commerce",
        features: {
          products: "Product management",
          payment: "Payment gateways",
          shipping: "Shipping"
        }
      },
      pos: {
        description: "Modern POS system",
        features: {
          sales: "Sales system",
          inventory: "Inventory management",
          reports: "Reports"
        }
      },
      wordpress: {
        description: "WordPress solutions",
        features: {
          cms: "Content management",
          plugins: "Plugins",
          themes: "Themes"
        }
      }
    },
    cta: {
      title: "Ready to start your project?",
      description: "Let us help you achieve your goals with powerful digital solutions"
    }
  },
  es: {
    hero: {
      badge: "Soluciones Web Profesionales",
      title: "Expertos en <span class='relative z-10 bg-gradient-to-r from-[#EA295A] to-[#FF6B6B] bg-clip-text text-transparent'>soluciones digitales</span>",
      description: "Ayudamos a las empresas a tener éxito en línea con soluciones web personalizadas, diseño profesional y servicio excepcional.",
      exploreServices: "Explorar Servicios",
      imageAlt: "Desarrollo Web"
    },
    stats: {
      clients: "Clientes Satisfechos",
      projects: "Proyectos Completados",
      uptime: "Tiempo de Actividad",
      support: "Soporte"
    },
    clients: {
      title: "Nuestros Clientes",
      description: "Estamos orgullosos de trabajar con empresas y organizaciones líderes"
    },
    services: {
      title: "Servicios",
      description: "Soluciones personalizadas adaptadas a tus necesidades y objetivos",
      webDevelopment: {
        description: "Soluciones web personalizadas que entregan resultados",
        features: {
          responsive: "Diseño responsive",
          seo: "Optimizado para SEO",
          fast: "Carga rápida"
        }
      },
      webDesign: {
        description: "Diseño moderno que captura la atención",
        features: {
          ux: "Diseño UX/UI",
          branding: "Diseño de marca",
          prototype: "Prototipado"
        }
      },
      webProgramming: {
        description: "Programación potente y eficiente",
        features: {
          custom: "Soluciones personalizadas",
          api: "Desarrollo de API",
          programming: "Programación"
        }
      },
      seo: {
        description: "Maximiza la visibilidad en línea",
        features: {
          keywords: "Análisis de palabras clave",
          technical: "Optimización técnica",
          content: "Optimización de contenido"
        }
      },
      marketing: {
        description: "Marketing digital dirigido",
        features: {
          social: "Redes sociales",
          ads: "Publicidad",
          content: "Marketing de contenidos"
        }
      },
      analytics: {
        description: "Análisis y mediciones detalladas",
        features: {
          google: "Google Analytics",
          heatmap: "Mapas de calor",
          testing: "Pruebas A/B"
        }
      }
    },
    solutions: {
      title: "Soluciones",
      description: "Soluciones personalizadas para tu empresa",
      ai: {
        description: "Soluciones de IA para empresas",
        features: {
          chatbot: "Chatbots",
          automation: "Automatización",
          analysis: "Análisis"
        }
      },
      booking: {
        description: "Sistemas de reservas automatizados",
        features: {
          online: "Reservas en línea",
          payment: "Pasarelas de pago",
          reminders: "Recordatorios"
        }
      },
      subscription: {
        description: "Soluciones de ingresos recurrentes",
        features: {
          management: "Gestión de suscripciones",
          payment: "Pagos",
          users: "Gestión de usuarios"
        }
      },
      ecommerce: {
        description: "Comercio electrónico potente",
        features: {
          products: "Gestión de productos",
          payment: "Pasarelas de pago",
          shipping: "Envíos"
        }
      },
      pos: {
        description: "Sistema POS moderno",
        features: {
          sales: "Sistema de ventas",
          inventory: "Gestión de inventario",
          reports: "Informes"
        }
      },
      wordpress: {
        description: "Soluciones WordPress",
        features: {
          cms: "Gestión de contenido",
          plugins: "Plugins",
          themes: "Temas"
        }
      }
    },
    cta: {
      title: "¿Listo para comenzar tu proyecto?",
      description: "Permítenos ayudarte a alcanzar tus objetivos con poderosas soluciones digitales"
    }
  },
  da: {
    hero: {
      badge: "Professionelle Webløsninger",
      title: "Eksperter i <span class='relative z-10 bg-gradient-to-r from-[#EA295A] to-[#FF6B6B] bg-clip-text text-transparent'>digitale løsninger</span>",
      description: "Vi hjælper virksomheder med at få succes online med skræddersyede webløsninger, professionelt design og enestående service.",
      exploreServices: "Udforsk Tjenester",
      imageAlt: "Webudvikling"
    },
    stats: {
      clients: "Tilfredse Kunder",
      projects: "Gennemførte Projekter",
      uptime: "Oppetid",
      support: "Support"
    },
    clients: {
      title: "Vores Kunder",
      description: "Vi er stolte af at arbejde med førende virksomheder og organisationer"
    },
    services: {
      title: "Tjenester",
      description: "Skræddersyede løsninger tilpasset dine behov og mål",
      webDevelopment: {
        description: "Skræddersyede webløsninger der leverer resultater",
        features: {
          responsive: "Responsivt design",
          seo: "SEO-venlig",
          fast: "Hurtig indlæsning"
        }
      },
      webDesign: {
        description: "Moderne design der fanger opmærksomheden",
        features: {
          ux: "UX/UI design",
          branding: "Brand design",
          prototype: "Prototype"
        }
      },
      webProgramming: {
        description: "Kraftfuld og effektiv programmering",
        features: {
          custom: "Skræddersyede løsninger",
          api: "API udvikling",
          programming: "Programmering"
        }
      },
      seo: {
        description: "Maksimerer online synlighed",
        features: {
          keywords: "Nøgleordsanalyse",
          technical: "Teknisk optimering",
          content: "Indholdsoptimering"
        }
      },
      marketing: {
        description: "Målrettet digital marketing",
        features: {
          social: "Sociale medier",
          ads: "Annoncering",
          content: "Content marketing"
        }
      },
      analytics: {
        description: "Detaljeret analyse og målinger",
        features: {
          google: "Google Analytics",
          heatmap: "Varmekort",
          testing: "A/B-test"
        }
      }
    },
    solutions: {
      title: "Løsninger",
      description: "Skræddersyede løsninger til din virksomhed",
      ai: {
        description: "AI-løsninger til virksomheder",
        features: {
          chatbot: "Chatbots",
          automation: "Automatisering",
          analysis: "Analyse"
        }
      },
      booking: {
        description: "Automatiserede bookingsystemer",
        features: {
          online: "Online booking",
          payment: "Betalingsgateways",
          reminders: "Påmindelser"
        }
      },
      subscription: {
        description: "Løsninger til tilbagevendende omsætning",
        features: {
          management: "Abonnementsstyring",
          payment: "Betalinger",
          users: "Brugerstyring"
        }
      },
      ecommerce: {
        description: "Kraftfuld e-handel",
        features: {
          products: "Produktstyring",
          payment: "Betalingsgateways",
          shipping: "Forsendelse"
        }
      },
      pos: {
        description: "Moderne POS-system",
        features: {
          sales: "Salgssystem",
          inventory: "Lagerstyring",
          reports: "Rapporter"
        }
      },
      wordpress: {
        description: "WordPress-løsninger",
        features: {
          cms: "Indholdsstyring",
          plugins: "Plugins",
          themes: "Temaer"
        }
      }
    },
    cta: {
      title: "Klar til at starte dit projekt?",
      description: "Lad os hjælpe dig med at nå dine mål med kraftfulde digitale løsninger"
    }
  }
};